export enum Env {
    LOCAL = 'local',
    DEVELOPMENT = 'development',
    STAGING = 'staging',
    QUALITY = 'quality',
    HOTFIX = 'hotfix',
    PRODUCTION = 'production'
}